module.exports = __webpack_public_path__ + "img/book-open-solid.cd3cb58a.svg";